import { Customer } from '../api/CustomersAPI';
import { CustomerStatus } from './customerStatusToTranslationKey';

export type CustomerListFilterCriteria = {
  statuses?: CustomerStatus[];
  employeeIds?: string[];
};

export function customerMatchesListFilters(
  customer: Customer,
  filters: CustomerListFilterCriteria,
): boolean {
  const { statuses, employeeIds } = filters;

  if (statuses && statuses.length > 0 && !statuses.includes(customer.status)) {
    return false;
  }

  if (employeeIds && employeeIds.length > 0) {
    const employeeId = customer.employeeId != null ? String(customer.employeeId) : '';
    if (!employeeIds.includes(employeeId)) {
      return false;
    }
  }

  return true;
}
